import React from "react";
import { classNames } from "../../../util/util-helpers";

export default function FieldContainer({addClass, labelType, label, children, message, hasError, hasMessagePlaceholder, leadingContent, trailingContent, leadingInnerContent, trailingInnerContent, fieldLabelClass, hasLabelPlaceholder, name}) {

    return (
        <div className={getFieldContainerClass(addClass, labelType)}>
            {label && (
                <React.Fragment>
                    <label htmlFor={name} className={getFieldLabelClass(labelType, fieldLabelClass)}>{label}</label>
                </React.Fragment>
            )}

            {!label && hasLabelPlaceholder && (
                <div className="h-5" />
            )}

            <div className="flex">
                {leadingContent}

                <div className={classNames(
                    hasError ? "border-red-600" : "border-gray-300",
                    "block relative text-default w-full bg-field shadow-sm sm:text-sm rounded-none"
                )}>
                    <div className="absolute left-3 top-0 bottom-0 flex items-center">
                        {leadingInnerContent}
                    </div>

                    {children}

                    <div className="absolute right-3 top-0 bottom-0 flex items-center">
                        {trailingInnerContent}
                    </div>
                </div>

                {trailingContent}
            </div>

            {!!message && (
                <p className={classNames("mt-2 leading-5 text-sm", hasError ? "text-red-600" : "text-gray-500")}>{message}</p>
            )}

            {!message && hasMessagePlaceholder && (
                <div className="h-5 mt-2" />
            )}
        </div>
    )
}

function getFieldContainerClass(addClass = "", labelType = "") {
    let fieldContainerClass = "";

    switch (labelType) {
        case 'left':
            fieldContainerClass = "relative text-default sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5";
            break;
        default:
            fieldContainerClass = "relative text-default"
    }

    fieldContainerClass = classNames(fieldContainerClass, addClass);

    return fieldContainerClass;
}

export function getFieldLabelClass(labelType, formLabelClass) {
    if (!formLabelClass) {
        switch (labelType) {
            case 'left':
                formLabelClass = "block text-sm font-semibold text-default-soft sm:mt-px sm:pt-2";
                break;
            case 'float':
                formLabelClass = "label text-default font-semibold absolute -top-2.5 left-2.5 label-bg px-1 text-xs z-10"
                break;
            case 'stack':
            default:
                formLabelClass = "flex items-center text-sm font-semibold text-default";
        }
    }

    return formLabelClass;
}